import * as React from 'react';
import * as classNames from 'classnames';
import { Icon } from './Icon';

export interface IEmptyBoxIconProps {
    className?: string;
}

const EmptyBoxIcon = (props: IEmptyBoxIconProps) => {
    const className = classNames('elc-empty-box-icon', props.className);
    const image = `url("data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' version='1.1' %3E%3Cpath d='M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' /%3E%3C/svg%3E")`;

    return <Icon className={className} size={'large'} image={image} />;
};

export { EmptyBoxIcon };
